export const TRIAL_CLASSROOM_PARAMS_BY_COURSE_ID: Record<number, { classLevel: number; classWeek: number }> = {
  6102: { classLevel: 3, classWeek: 1 },
  6103: { classLevel: 4, classWeek: 1 },
  6104: { classLevel: 5, classWeek: 10 },
  6105: { classLevel: 7, classWeek: 1 },
  6106: { classLevel: 1, classWeek: 1 },
  6107: { classLevel: 1, classWeek: 4 },
  6108: { classLevel: 2, classWeek: 1 },
  6109: { classLevel: 3, classWeek: 1 },
  6110: { classLevel: 4, classWeek: 1 },
  6111: { classLevel: 5, classWeek: 1 },
  6112: { classLevel: 8, classWeek: 1 },
}

export const resolveTrialClassroomParamsByCourseId = (classCourseId: number, classLevel: number, classWeek: number) => {
  return TRIAL_CLASSROOM_PARAMS_BY_COURSE_ID[classCourseId] ?? { classLevel, classWeek }
}
